import React, { Suspense, useEffect } from 'react';
import ReactDOM from 'react-dom/client';
import store, { history } from './store';
import { theme } from '../theme/theme';

import { Provider, useSelector } from 'react-redux';
import { ThemeProvider } from 'styled-components';
import { HistoryRouter as Router } from 'redux-first-history/rr6';

import '../asset/styled/common/reset.css';
import '../asset/styled/common/designSystem.css';

import MainRoute from './MainRouter';
import { AlertProvider } from '../context/AlertContext';
import Loading from '../components/common/Loading';
import GlobalDialog from '../components/common/GlobalDialog';

import '../i18n';
// Suspense를 사용하기 위해 추가
import { I18nextProvider } from 'react-i18next';
import i18n from '../i18n';

/* 개발모드 일때만 콘솔 로그 보이도록 함 */
if (process.env.options.mode !== 'development') {
  console.log = () => {};
} else {
  console.log('development mode');
}

const App = () => {
  const isLoading = useSelector(state => state?.loading?.isLoading);

  return (
    <ThemeProvider theme={theme}>
      <AlertProvider>
        {/* <ConfirmProvider> */}
        {isLoading && <Loading />}
        <MainRoute />
        <GlobalDialog />
        {/* </ConfirmProvider> */}
      </AlertProvider>
    </ThemeProvider>
  );
};

ReactDOM.createRoot(document.getElementById('root')).render(
  <Provider store={store}>
    <Router history={history}>
      <I18nextProvider i18n={i18n}>
        <Suspense fallback={<Loading />}>
          <App />
        </Suspense>
      </I18nextProvider>
    </Router>
  </Provider>,
);
